"use client";

import React from "react";
import { CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = ["Supports accessible healthcare", "Enables patient assistance programs", "Funds delivery for underserved communities", "Provides essential medical supplies", "Directly impacts local patient care"];
export default function DonationImpact() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261719" id="donation-impact" className="bg-background py-16 md:py-24 overflow-hidden text-foreground" ref={sectionRef}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {}
          <div className={`flex flex-col items-start text-left relative transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="absolute -left-4 md:-left-6 top-2 bottom-2 w-1.5 bg-primary rounded-md" />

            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-default text-foreground mb-6 leading-tight">
              Your Contribution <br className="hidden md:block" />
              <span className="text-primary">Changes Lives Daily</span>
            </h2>
            
            <p className="text-lg text-muted-foreground mb-8 max-w-xl leading-relaxed font-default">
              Every donation fuels our mission to bridge the gap in healthcare accessibility. Your support ensures that no patient is left behind due to financial or logistical barriers.
            </p>

            <ul className="space-y-4 mb-10">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-foreground font-medium">
                  <CircleCheck className="w-6 h-6 text-secondary shrink-0" />
                  <span className="text-base md:text-lg font-default">{benefit}</span>
                </li>)}
            </ul>

            <Button size="lg" className="text-base px-8 h-12 bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-md" asChild>
              <Link to="/PatientSupportPage">
                Support Our Mission
                <ArrowRight className="ml-2 w-5 h-5" />
              </Link>
            </Button>
          </div>

          {}
          <div className={`relative rounded-2xl overflow-hidden shadow-xl transition-all duration-1000 delay-200 ease-out bg-card p-8 flex flex-col items-center justify-center ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <img src="https://decent-seal.10web.cloud/wp-content/uploads/2026/05/Screenshot-2026-05-23-at-12.52.44.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/donation_qr_code.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1651003/img/donation_qr_code.png-wvc-sizes" alt="Scan to donate to our healthcare mission" className="w-64 h-64 object-contain aspect-square mb-6" loading="lazy" />
            <div className="text-center">
              <p className="text-xl font-bold font-default text-foreground mb-2">Scan to donate</p>
              <p className="text-sm text-muted-foreground font-default">Or use the donation form below</p>
            </div>
            {}
            <div className="absolute inset-0 bg-gradient-to-tr from-secondary/10 to-transparent mix-blend-overlay pointer-events-none" />
          </div>

        </div>
      </div>
    </section>;
}